import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OrganizationsNavigationProvider } from '../../organizations/providers/navigation-provider';
import { CurrentUser } from "../../common/providers/current-user";
import { Organization } from "../../common/models/organization";
import { Library } from "../../common/models/library";
import { map, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { ExercicesProvider } from "../providers/exercices-provider";

@Injectable({providedIn: 'root'})
export class ExercicesLibraryRedirect implements CanActivate {
    constructor(
        private _currentUser: CurrentUser,
        private _organizationNavigation: OrganizationsNavigationProvider,
        private _router: Router,
        private exercicesProvider: ExercicesProvider,
        private api: ApiBaseService,
    ) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
            return this.redirect(route).pipe(
              map((organization: Organization | null) => {
                if (!organization) {
                  this._router.navigate(['/']);
                  return false;
                } else {
                  return true;
                }
            }),
          );
    }

    private redirect(route: ActivatedRouteSnapshot): Observable<any> {
      // on redirige vers la première library à laquelle a accès ce user
      return this._organizationNavigation.getOrganisationFromRoute('/' + route.url.join('/')).pipe(
        switchMap((organization: Organization | null) => {
          if (!organization) {
            return of(null);
          }
          return this.exercicesProvider.getLibraries(organization.id!).pipe(
            switchMap((libraries: Library[]) => {
              if (libraries.length === 0) {
                return of(null);
              }
              return this._currentUser.getCurrentUser().pipe(
                map((user) => {
                  this._router.navigate([organization.code, 'libraries', libraries[0].id, 'exercises', 'personal']);
                  return organization;
                })
              );
            }),
          );
      }),
      );
    }

}
